<template>
  <div
    class="modal fade show"
    tabindex="-1"
    style="display: block; background: rgba(0,0,0,0.5);"
    v-if="mostrar"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content shadow-lg">
        <div class="modal-header py-2">
          <h5 class="modal-title font-size-15 d-flex align-items-center">
            <i class="mdi mdi-whatsapp text-success me-2 font-size-20"></i>
            Plantillas en Meta Cloud API (WABA ID: {{ wabaId }})
          </h5>
          <button
            type="button"
            class="btn-close"
            @click="$emit('cerrar')"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-3">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted font-size-13">
              Total de plantillas registradas en el sistema: <strong>{{ plantillas.length }}</strong>
            </span>
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              @click="$emit('refrescar')"
              :disabled="cargando"
            >
              <i class="mdi me-1" :class="cargando ? 'mdi-concourse-ci mdi-spin' : 'mdi-refresh'"></i>
              Refrescar lista
            </button>
          </div>

          <div class="table-responsive" v-if="plantillas.length > 0">
            <table class="table table-sm table-bordered table-hover align-middle mb-0 font-size-13">
              <thead>
                <tr>
                  <th>Nombre de Template</th>
                  <th>Categoría</th>
                  <th>Idioma</th>
                  <th>Estado en Meta</th>
                  <th>ID de Plantilla</th>
                  <th class="text-center" style="width: 100px;">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="m in plantillas" :key="m.id">
                  <td class="fw-semibold font-monospace text-primary">
                    {{ m.name }}
                    <span v-if="m.name === 'confirmacion_pago' || m.name === 'inicio_conversacion'" class="badge bg-success ms-1">Oficial ISP</span>
                  </td>
                  <td>
                    <span class="badge bg-secondary bg-opacity-10 text-body border font-size-11">
                      {{ m.category || 'UTILITY' }}
                    </span>
                  </td>
                  <td>
                    <span class="badge bg-secondary bg-opacity-10 text-body border font-monospace">
                      {{ m.language }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="{
                        'bg-success': m.status === 'APPROVED',
                        'bg-warning text-dark': m.status === 'PENDING',
                        'bg-danger': m.status === 'REJECTED',
                        'bg-secondary': m.status === 'PAUSED' || m.status === 'DISABLED'
                      }"
                    >
                      {{ etiquetaEstadoMeta(m.status) }}
                    </span>
                  </td>
                  <td class="font-monospace text-muted font-size-11">{{ m.id }}</td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger py-0 px-2 font-size-11"
                      @click="$emit('eliminar', m)"
                      :disabled="eliminando === (m.id || m.name)"
                      title="Eliminar plantilla de Meta Cloud API"
                    >
                      <i class="mdi me-1" :class="eliminando === (m.id || m.name) ? 'mdi-concourse-ci mdi-spin' : 'mdi-trash-can-outline'"></i>
                      {{ eliminando === (m.id || m.name) ? '...' : 'Eliminar' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="alert alert-info mb-0" v-else>
            <i class="mdi mdi-information-outline me-1"></i>
            No se encontraron plantillas del sistema registradas en esta cuenta de Meta WhatsApp Business (WABA). Puede registrar la plantilla usando el botón <strong>"Crear en Meta API"</strong> en el editor.
          </div>
        </div>
        <div class="modal-footer py-2 d-flex justify-content-between align-items-center">
          <button
            type="button"
            class="btn btn-success btn-sm d-inline-flex align-items-center"
            @click="$emit('guardar-sincronizacion')"
            :disabled="cargando"
            title="Guarda y actualiza los estados consultados de Meta en la base de datos del sistema"
          >
            <i class="mdi mdi-content-save-check-outline me-1"></i>
            Guardar Sincronización en el Sistema
          </button>
          <button
            type="button"
            class="btn btn-secondary btn-sm"
            @click="$emit('cerrar')"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MdlPlantillasMeta',
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    wabaId: {
      type: String,
      default: ''
    },
    plantillas: {
      type: Array,
      default: () => []
    },
    cargando: {
      type: Boolean,
      default: false
    },
    eliminando: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    etiquetaEstadoMeta(status) {
      if (!status) return 'No consultado'
      switch (status.toUpperCase()) {
        case 'APPROVED': return 'Aprobada'
        case 'PENDING': return 'En Revisión'
        case 'REJECTED': return 'Rechazada'
        case 'PAUSED': return 'Pausada'
        case 'DISABLED': return 'Deshabilitada'
        case 'NO_REGISTRADA': return 'No Registrada'
        default: return status
      }
    }
  }
}
</script>
